export default __webpack_public_path__ + "static/media/Flag-uk.30ece7ac.svg";